import { Dialog } from 'src/common/components/Dialog/Dialog';
import Portal from '@mui/material/Portal';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'src/common/components/Buttons/Button';
import { useESimProfileEnable } from './hooks/useESimProfileEnable';
import { useState } from 'react';
import { AlertTitle } from 'src/common/Snackbar/AlertTitle';
import { AutoHideSnackbar } from 'src/common/Snackbar/AutoHideSnackbar';
import Typography from '@mui/material/Typography';
import { ESimProfile } from '../models/eSimProfiles';

type ESimEnableDialogProps = {
  open: boolean;
  onClose: () => void;
  data: ESimProfile;
};

export const ESimEnableProfileDialog = ({ open, onClose, data }: ESimEnableDialogProps) => {
  const { t } = useTranslation();

  const [isSuccess, setIsSuccess] = useState(false);
  const { enableESimProfile } = useESimProfileEnable({
    eid: data?.esimEid,
    iccid: data?.iccid,
    mutationOption: {
      onSuccess: () => {
        onClose();
        setIsSuccess(true);
      },
    },
  });

  return (
    <>
      {data && (
        <Dialog
          fullWidth={false}
          open={open}
          title={t('products.eSim.inventory.actions.enable.title')}
          onClose={onClose}
          size="small"
          actions={
            <>
              <Button variant="secondary" onClick={onClose}>
                {t('common.cancel')}
              </Button>
              <Button variant="primary" onClick={() => enableESimProfile()}>
                {t('common.confirm')}
              </Button>
            </>
          }
        >
          <Typography variant="text1">
            <Trans
              style={{ 'white-space': 'pre-wrap' }}
              i18nKey={'products.eSim.inventory.actions.enable.description'}
              values={{ iccid: data.iccid }}
              components={{ 1: <strong /> }}
            />
          </Typography>
        </Dialog>
      )}
      <Portal>
        <AutoHideSnackbar
          severity="info"
          open={isSuccess}
          onClose={() => {
            setIsSuccess(false);
          }}
        >
          <AlertTitle>{t('products.eSim.inventory.actions.enable.success.title')}</AlertTitle>
          <Typography variant="text1" color="text.white">
            {t('products.eSim.inventory.actions.enable.success.description')}
          </Typography>
        </AutoHideSnackbar>
      </Portal>
    </>
  );
};
